import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const PLACENET_TOKEN_STORAGE_KEY = "placenet_auth_token";

let placenetAuthFailed = false;

export function resetPlacenetAuthFailure() {
  placenetAuthFailed = false;
}

export function setToTruePlacenetAuthFailure() {
  placenetAuthFailed = true;
}

export function getStoredPlacenetToken() {
  return (
    (window as any).__authToken ||
    sessionStorage.getItem(PLACENET_TOKEN_STORAGE_KEY) ||
    null
  );
}

export function clearStoredPlacenetToken() {
  delete (window as any).__authToken;
  sessionStorage.removeItem(PLACENET_TOKEN_STORAGE_KEY);
}

export function storePlacenetToken(token: string) {
  (window as any).__authToken = token;
  sessionStorage.setItem(PLACENET_TOKEN_STORAGE_KEY, token);
}

export function usePlacenetAuth() {
  const [token, setToken] = useState<string | null>(() =>
    getStoredPlacenetToken()
  );

  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlToken = params.get("token");

    const applyToken = (nextToken: string) => {
      storePlacenetToken(nextToken);
      setToken(nextToken);
    };

    if (urlToken) {
      applyToken(urlToken);

      const url = new URL(window.location.href);
      url.searchParams.delete("token");

      window.history.replaceState(
        {},
        "",
        `${url.pathname}${url.search}${url.hash}`
      );
    }

    const currentToken = getStoredPlacenetToken();
    const isIframe = window.parent !== window;

    if (!currentToken && isIframe && !placenetAuthFailed) {
      try {
        window.parent.postMessage("READY", "*");
      } catch (e) {
        console.warn("Could not post READY to parent:", e);
      }
    }

    function handleMessage(event: MessageEvent) {
      const data = event.data;

      if (data?.type === "auth" && data?.token) {
        applyToken(data.token);

        if (data.goto) {
          navigate(data.goto, { replace: true });
        }
      }

      if (data?.type === "goto" && data?.path) {
        navigate(data.path);
      }
    }

    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, [navigate]);

  return token;
}
